/**
 * Calcul du prix au prorata, heure par heure
 */
export function computePrice({ fromISO, toISO, weekDayPerDay, weekendPerDay }) {
  if (!fromISO || !toISO) return { valid: false };

  const start = new Date(fromISO);
  const end = new Date(toISO);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
    return { valid: false };
  if (end <= start) return { valid: false };

  const weekRatePerHour = weekDayPerDay / 24;
  const weekendRatePerHour = weekendPerDay / 24;

  let weekHours = 0;
  let weekendHours = 0;

  let cursor = new Date(start);
  while (cursor < end) {
    const next = new Date(
      Math.min(end.getTime(), cursor.getTime() + 60 * 60 * 1000)
    );

    const mid = new Date((cursor.getTime() + next.getTime()) / 2);

    if (isWeekendWindow(mid))
      weekendHours += (next - cursor) / (60 * 60 * 1000);
    else weekHours += (next - cursor) / (60 * 60 * 1000);

    cursor = next;
  }

  const totalRaw =
    weekHours * weekRatePerHour + weekendHours * weekendRatePerHour;

  const total = formatMoney(totalRaw);

  return {
    valid: true,
    weekHours: stripTrailingZeros(weekHours),
    weekendHours: stripTrailingZeros(weekendHours),
    total,
  };
}

function isWeekendWindow(date) {
  const day = date.getDay();
  const hour = date.getHours();

  if (day === 5) return hour >= 12; // Friday from 12:00
  if (day === 6) return true; // Saturday
  if (day === 0) return true; // Sunday
  return false;
}

function formatMoney(n) {
  return new Intl.NumberFormat("fr-CH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

function stripTrailingZeros(n) {
  const s = String(Number(n.toFixed(6)));
  return s.replace(/\.0+$/, "").replace(/(\.\d*[1-9])0+$/, "$1");
}